var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000B31",
    d: "M21.082 12.04a.87.87 0 0 1-.619-.257L14 5.32l-6.463 6.463a.88.88 0 0 1-1.237 0 .88.88 0 0 1 0-1.236l7.082-7.082a.88.88 0 0 1 1.236 0l7.082 7.082a.88.88 0 0 1 0 1.236.85.85 0 0 1-.618.257"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000B31",
    d: "M14 24.792a.88.88 0 0 1-.875-.875V4.282c0-.479.397-.875.875-.875s.875.396.875.875v19.635a.88.88 0 0 1-.875.875"
  })));
};
export default SvgArrowUp;